import { render, staticRenderFns } from "./SingleDocumentSummary.component.vue?vue&type=template&id=f155ff8c"
import script from "./SingleDocumentSummary.component.vue?vue&type=script&lang=js"
export * from "./SingleDocumentSummary.component.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports